import { gql } from '@apollo/client'

export const Query = gql`
  query MaintenanceSchedules(
    $companyId: ID!, 
    $filters: MaintenanceScheduleFilters, 
    $after: String, 
    $before: String, 
    $first: Int, 
    $last: Int
  ) {
    maintenanceSchedules(
      companyId: $companyId, 
      filters: $filters, 
      after: $after, 
      before: $before, 
      first: $first, 
      last: $last
    ) {
      nodes {
        id
        maintenanceType {
          id
          name
        }
        details
        repeatMultiplier
        repeatPeriod
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
